(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["estimate-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cwEstimateDeliveryInit) return;
    window.__cwEstimateDeliveryInit = true;

      /* ------------------------------------------------------------------
       * Blue Dart credentials (production).
       * TODO: move behind a Shopify App Proxy before this is considered done.
       * Anyone can read these from the compiled theme JS asset, and this same
       * credential set can generate waybills billed to the account.
       * ------------------------------------------------------------------ */
      var BASE_URL = 'https://apigateway.bluedart.com/in/transportation';
      var CLIENT_ID = 'ZJmO2ZWB4SJ0Z2aWfAWcEcPL6E6m5qHy';
      var CLIENT_SECRET = 'Ze4GHEmgkkP4ka9u';
      var LOGIN_ID = 'BOM29945';
      var LICENCE_KEY = 'ujxgeqeehke4hhqppoutejqfpuoljsyi';
  
      /* Contracted product only: Etail Apex (Prepaid + COD).
         Do NOT add 'E' (Surface) or 'D' (Domestic Priority) as fallbacks --
         the API will happily quote a date for a product we cannot book. */
      var PRODUCT_CODE = 'A';
      var SUB_PRODUCT_CODE = 'P';
  
      /* Serviceability flags that correspond to the Apex/Etail contract. */
      var INBOUND_KEYS = [
        'eTailPrePaidAirInbound',
        'eTailCODAirInbound',
        'eTailExpressPrePaidAirInbound',
        'eTailExpressCODAirInbound',
        'ApexInbound'
      ];
  
      var IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;
      var DAY_MS = 24 * 60 * 60 * 1000;
      var MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
      var MONTH_LABEL = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var WEEKDAY_LABEL = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  
      /* Indian PIN codes start 1-8. 9xxxxx is Army Postal Service and the
         Blue Dart finder happily returns a bogus "serviceable" row for it. */
      var PINCODE_RE = /^[1-8]\d{5}$/;
  
      var FRIENDLY_ERRORS = {
        INVALIDPINCODE: 'Please enter a valid pincode',
        INBOUNDSERVICENOTAVAILABLE: 'Delivery is not available for this pincode',
        OUTBOUNDSERVICENOTAVAILABLE: 'Delivery is not available for this pincode',
        SERVICENOTAVAILABLE: 'Delivery is not available for this pincode',
        EMBARGO: 'Delivery is temporarily suspended for this pincode'
      };
  
      /* ---------------------------- IST date helpers ---------------------- */
  
      function istFields(ms) {
        var shifted = new Date(ms + IST_OFFSET_MS);
        return {
          year: shifted.getUTCFullYear(),
          month: shifted.getUTCMonth(),
          date: shifted.getUTCDate(),
          hours: shifted.getUTCHours(),
          minutes: shifted.getUTCMinutes(),
          weekday: shifted.getUTCDay()
        };
      }
  
      /* UTC timestamp for 00:00 IST on the given IST calendar day. */
      function istMidnight(fields) {
        return Date.UTC(fields.year, fields.month, fields.date) - IST_OFFSET_MS;
      }
  
      function istWeekday(ms) {
        return new Date(ms + IST_OFFSET_MS).getUTCDay();
      }
  
      function parseClock(value, fallbackMinutes) {
        var match = String(value || '').match(/^(\d{1,2}):(\d{2})$/);
        if (!match) return fallbackMinutes;
        var hours = Number(match[1]);
        var minutes = Number(match[2]);
        if (hours > 23 || minutes > 59) return fallbackMinutes;
        return hours * 60 + minutes;
      }
  
      function formatClock(totalMinutes) {
        var hours = Math.floor(totalMinutes / 60);
        var minutes = totalMinutes % 60;
        return (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
      }
  
      function parseClosedDays(value) {
        var map = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };
        var closed = {};
        String(value || '')
          .toLowerCase()
          .split(',')
          .forEach(function (part) {
            var key = part.trim().slice(0, 3);
            if (key in map) closed[map[key]] = true;
          });
        return closed;
      }
  
      /*
       * The date Blue Dart quotes assumes the parcel is physically handed over
       * at the pickup slot we send. So we send the slot we can actually meet:
       * today's cutoff if it has not passed, otherwise the next working day,
       * plus however many days packing takes.
       */
      function handoverPickup(config) {
        var now = Date.now();
        var fields = istFields(now);
        var minutesNow = fields.hours * 60 + fields.minutes;
  
        var offsetDays = minutesNow >= config.cutoffMinutes ? 1 : 0;
        offsetDays += config.dispatchDays;
  
        var target = istMidnight(fields) + offsetDays * DAY_MS;
  
        var guard = 0;
        while (config.closedDays[istWeekday(target)] && guard < 14) {
          target += DAY_MS;
          guard += 1;
        }
  
        return {
          /* Noon IST -- unambiguous whichever way the gateway reads the epoch. */
          pudate: '/Date(' + (target + 12 * 60 * 60 * 1000) + ')/',
          pickupTime: formatClock(config.cutoffMinutes)
        };
      }
  
      /* Blue Dart returns "04-SEP-26". Parse the string directly -- routing it
         through `new Date()` builds a local-midnight Date that renders as the
         previous day for anyone browsing from a timezone behind IST. */
      function formatDeliveryDate(value) {
        if (typeof value !== 'string') return '';
        var match = value.trim().toUpperCase().match(/^(\d{1,2})-([A-Z]{3})-(\d{2,4})$/);
        if (!match) return '';
  
        var day = Number(match[1]);
        var monthIndex = MONTHS.indexOf(match[2]);
        if (monthIndex < 0) return '';
        var year = match[3].length === 2 ? 2000 + Number(match[3]) : Number(match[3]);
  
        var weekday = WEEKDAY_LABEL[new Date(Date.UTC(year, monthIndex, day)).getUTCDay()];
        return weekday + ', ' + day + ' ' + MONTH_LABEL[monthIndex] + ' ' + year;
      }
  
      function titleCase(value) {
        return String(value || '')
          .toLowerCase()
          .replace(/\b[a-z]/g, function (character) {
            return character.toUpperCase();
          });
      }
  
      /* ------------------------------ API layer --------------------------- */
  
      function isYes(value) {
        if (value === true || value === 1) return true;
        if (typeof value !== 'string') return false;
        var normalized = value.trim().toUpperCase();
        return normalized === 'Y' || normalized === 'YES' || normalized === 'TRUE' || normalized === '1';
      }
  
      /* Unwrap both the success envelope and the `error-response` array that
         Blue Dart returns alongside HTTP 400. */
      function unwrap(data) {
        if (!data || typeof data !== 'object') return data;
  
        if (Array.isArray(data['error-response']) && data['error-response'].length) {
          return data['error-response'][0];
        }
  
        var keys = [
          'GetServicesforPincodeResult',
          'GetServicesforPincodeResponse',
          'GetDomesticTransitTimeForPinCodeandProductResult',
          'DomesticTranistTimeReference',
          'DomesticTransitTimeReference',
          'ServiceCenterDetailsReference',
          'ServiceCenterDetails',
          'result',
          'Result',
          'data',
          'Data'
        ];
  
        for (var i = 0; i < keys.length; i++) {
          if (data[keys[i]] && typeof data[keys[i]] === 'object') return unwrap(data[keys[i]]);
        }
  
        return data;
      }
  
      function parseJson(response) {
        return response.text().then(function (raw) {
          if (!raw) return {};
          try {
            return JSON.parse(raw);
          } catch (error) {
            return {};
          }
        });
      }
  
      /* Blue Dart signals "no service on this lane" with HTTP 200,
         IsError:false and a null date -- only ErrorMessage tells the truth. */
      function isValid(details) {
        if (!details) return false;
        if (details.IsError === true || isYes(details.IsError)) return false;
        var message = String(details.ErrorMessage || '').trim().toUpperCase();
        return message === '' || message === 'VALID';
      }
  
      function friendlyError(details, fallback) {
        var raw = String((details && details.ErrorMessage) || '').trim();
        var key = raw.toUpperCase().replace(/[^A-Z]/g, '');
        if (FRIENDLY_ERRORS[key]) return FRIENDLY_ERRORS[key];
        return fallback;
      }
  
      /* --- JWT cache. The token is valid 24h; the old code minted a fresh one
         on every keystroke-submit, tripling latency and API load. --- */
      var tokenCache = { value: '', expiresAt: 0, inflight: null };
  
      function tokenExpiry(token) {
        try {
          var payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
          if (payload && payload.exp) return payload.exp * 1000;
        } catch (error) {
          /* fall through */
        }
        return Date.now() + 30 * 60 * 1000;
      }
  
      function getJwt() {
        var now = Date.now();
        if (tokenCache.value && now < tokenCache.expiresAt) {
          return Promise.resolve(tokenCache.value);
        }
        if (tokenCache.inflight) return tokenCache.inflight;
  
        tokenCache.inflight = fetch(BASE_URL + '/token/v1/login', {
          method: 'GET',
          headers: {
            ClientID: CLIENT_ID,
            clientSecret: CLIENT_SECRET,
            Accept: 'application/json'
          }
        })
          .then(function (response) {
            return parseJson(response).then(function (body) {
              var token = '';
              if (typeof body === 'string') token = body.replace(/^"|"$/g, '').trim();
              else if (body) token = body.JWTToken || body.jwtToken || body.JwtToken || body.token || '';
              if (!response.ok || !token) throw new Error('auth');
  
              tokenCache.value = token;
              /* Refresh five minutes early so a check never straddles expiry. */
              tokenCache.expiresAt = tokenExpiry(token) - 5 * 60 * 1000;
              return token;
            });
          })
          .then(
            function (token) {
              tokenCache.inflight = null;
              return token;
            },
            function (error) {
              tokenCache.inflight = null;
              throw error;
            }
          );
  
        return tokenCache.inflight;
      }
  
      function profile() {
        return { Api_type: 'S', LicenceKey: LICENCE_KEY, LoginID: LOGIN_ID };
      }
  
      function postJson(path, token, payload, tag) {
        return fetch(BASE_URL + path, {
          method: 'POST',
          headers: {
            JWTToken: token,
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        }).then(function (response) {
          return parseJson(response).then(function (body) {
            var details = unwrap(body) || {};
            /* A 400 carrying a usable ErrorMessage is data, not a failure --
               only throw when there is genuinely nothing to report. */
            if (!response.ok && !details.ErrorMessage) throw new Error(tag);
            return details;
          });
        });
      }
  
      function getServices(token, pincode) {
        return postJson('/finder/v1/GetServicesforPincode', token, {
          pinCode: pincode,
          profile: profile()
        }, 'lookup');
      }
  
      function getTransitTime(token, destination, pickup, originPincode) {
        return postJson('/transit/v1/GetDomesticTransitTimeForPinCodeandProduct', token, {
          pPinCodeFrom: originPincode,
          pPinCodeTo: destination,
          pProductCode: PRODUCT_CODE,
          pSubProductCode: SUB_PRODUCT_CODE,
          pPudate: pickup.pudate,
          pPickupTime: pickup.pickupTime,
          profile: profile()
        }, 'transit');
      }
  
      /* ------------------------------- UI --------------------------------- */
  
      function setStatus(root, type, message, note) {
      var status = root.querySelector('[data-estimate-status]');
      if (!status) return;
  
      status.className = status.className
        .replace(/\bis-visible\b/g, '')
        .replace(/\bis-loading\b/g, '')
        .replace(/\bis-success\b/g, '')
        .replace(/\bis-error\b/g, '')
        .trim();
  
        status.textContent = '';
        if (!message) return;
  
        status.appendChild(document.createTextNode(message));
  
        if (note) {
          var small = document.createElement('span');
          small.className = status.className.split(' ')[0].replace('__status', '__note');
          small.textContent = note;
          status.appendChild(small);
        }
  
      status.classList.add('is-visible', 'is-' + type);
    }
  
      function check(config, pincode) {
        var pickup = handoverPickup(config);
  
        return getJwt().then(function (token) {
          return getServices(token, pincode).then(function (services) {
            if (!isValid(services)) {
              return { type: 'error', message: friendlyError(services, 'Please enter a valid pincode') };
            }
  
            if (isYes(services.Embargo)) {
              return { type: 'error', message: 'Delivery is temporarily suspended for this pincode' };
            }
  
            var serviceable = INBOUND_KEYS.some(function (key) {
              return isYes(services[key]);
            });
  
            if (!serviceable) {
              return { type: 'error', message: 'Delivery is not available for this pincode' };
            }
  
            var city = config.showCity ? titleCase(services.CityDescription || services.PincodeDescription) : '';
  
            return getTransitTime(token, pincode, pickup, config.originPincode).then(function (transit) {
              if (!isValid(transit)) {
                return { type: 'error', message: friendlyError(transit, 'Delivery is not available for this pincode') };
              }
  
              var date = formatDeliveryDate(transit.ExpectedDateDelivery || transit.ExpectedDatePOD);
  
              if (!date) {
                return {
                  type: 'success',
                  message: city ? 'Delivery available to ' + city + '.' : 'Delivery available for this pincode.'
                };
              }
  
              return {
                type: 'success',
                message: (city ? 'Delivery to ' + city + ' — estimated by ' : 'Estimated delivery by ') + date,
                note: config.noteText
              };
            });
          });
        });
      }
  
      function readConfig(root) {
        var cutoffMinutes = parseClock(root.getAttribute('data-cutoff'), 16 * 60);
        var dispatchDays = parseInt(root.getAttribute('data-dispatch-days'), 10);
        var origin = String(root.getAttribute('data-origin-pincode') || '').replace(/\D/g, '');
  
        return {
          originPincode: origin.length === 6 ? origin : '400001',
          cutoffMinutes: cutoffMinutes,
          dispatchDays: isNaN(dispatchDays) || dispatchDays < 0 ? 0 : dispatchDays,
          closedDays: parseClosedDays(root.getAttribute('data-closed-days')),
          showCity: root.getAttribute('data-show-city') === 'true',
          noteText: 'Order before ' + formatClock(cutoffMinutes) + ' for same-day dispatch.'
        };
      }

    function init(root) {
      if (root.dataset.estimateReady === 'true') return;
      root.dataset.estimateReady = 'true';

        var config = readConfig(root);
      var form = root.querySelector('form');
        var input = root.querySelector('[data-pincode-input]');
      var button = root.querySelector('button[type="submit"]');
      var label = root.querySelector('[data-estimate-label]');
      var idleLabel = label ? label.textContent : 'Check';
        var cache = {};
        var busy = false;

      input.addEventListener('input', function () {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
        if (!input.value) setStatus(root, '', '');
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
          if (busy) return;
  
        var pincode = (input.value || '').trim();

        if (!PINCODE_RE.test(pincode)) {
            setStatus(root, 'error', 'Please enter a valid 6-digit pincode');
          input.focus();
          return;
        }

          if (cache[pincode]) {
            setStatus(root, cache[pincode].type, cache[pincode].message, cache[pincode].note);
          return;
        }

          busy = true;
        button.disabled = true;
        if (label) label.textContent = 'Checking';
        setStatus(root, 'loading', 'Checking delivery…');

          check(config, pincode)
            .then(function (result) {
              /* Only cache settled answers, never transient failures. */
              cache[pincode] = result;
              setStatus(root, result.type, result.message, result.note);
            })
            .catch(function (error) {
              if (window.console && console.warn) {
                console.warn('[estimate-delivery] Blue Dart request failed:', error);
              }
            setStatus(root, 'error', 'Unable to check delivery right now. Please try again.');
          })
          .then(function () {
              busy = false;
            button.disabled = false;
            if (label) label.textContent = idleLabel;
          });
      });
    }

    function scan() {
      document.querySelectorAll('[data-estimate-delivery]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', scan);
      document.addEventListener('shopify:block:select', scan);
  })();
  } catch(e) { console.error(e); }
})();

})();
